// src/components/ui/StatCard.jsx
// Tarjeta compacta de indicador (KPI). Reutilizable en cualquier listado/dashboard.
const TONES = {
  blue: "bg-blue-50 text-blue-600",
  green: "bg-green-50 text-green-600",
  amber: "bg-amber-50 text-amber-600",
  red: "bg-red-50 text-red-600",
  gray: "bg-gray-100 text-gray-500",
  indigo: "bg-indigo-50 text-indigo-600",
};

const StatCard = ({ icon: Icon, label, value, tone = "blue", active = false, onClick }) => {
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`flex items-center gap-3 w-full text-left bg-white rounded-xl border p-4 shadow-sm transition-all ${
        active ? "border-blue-400 ring-2 ring-blue-100" : "border-gray-200"
      } ${onClick ? "hover:border-blue-300 hover:shadow-md cursor-pointer" : ""}`}
    >
      {Icon && (
        <span className={`p-2.5 rounded-lg shrink-0 ${TONES[tone] || TONES.blue}`}>
          <Icon className="h-5 w-5" />
        </span>
      )}
      <span className="min-w-0">
        <span className="block text-xs font-medium text-gray-500 truncate">{label}</span>
        <span className="block text-xl font-bold text-gray-900 leading-tight">{value}</span>
      </span>
    </Wrapper>
  );
};

export default StatCard;
